furbo.article={};
furbo.article.initShare=function(){
  var share=document.getElementById("share");
  var shareTrigger=document.getElementById("share-trigger");
  var refer=share.parentNode;
  if(window.screen.width>500){
    share.style.left=(refer.offsetLeft+refer.offsetWidth+5)+"px";
    window.addEventListener("scroll", function(){
      if(document.body.scrollTop>refer.offsetHeight-600){
        share.style.display="none";
      }else{
        share.style.display="block";
      }
    });
  }else{
    shareTrigger.style.display="block";
  	share.style.right="20px";
    share.style.bottom="60px"
    share.style.height="0px";
    share.addEventListener("blur", furbo.article.hideShare);
  }
  share.style.display="block";
};
furbo.article.showShare=function(){
  var share=document.getElementById("share");
  var shareTrigger=document.getElementById("share-trigger");
  shareTrigger.style.display="none";
  share.style.height="159px";
  share.focus();
};
furbo.article.hideShare=function(){
  var share=document.getElementById("share");
  var shareTrigger=document.getElementById("share-trigger");
  share.style.height="0px";
  window.setTimeout(function(){
    shareTrigger.style.display="block";
  }, 500);
};